import dayjs, { type Dayjs } from 'dayjs'
import global from '@/common/global'
import { isString, isArray, isNumber } from './validate'
import { isDev, typeViteEnv } from '@/utils/env'

export function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod|Windows Phone|BlackBerry|Tablet|Kindle/i.test(navigator.userAgent)
}

/**
 * @Author      gaoxiang
 * @DateTime    2020/7/23
 * @lastTime    2020/7/23
 * @description 去除空格
 */
export function trim(str: string, isGlobal?: boolean) {
  if (typeof str === 'undefined' || str.length === 0) return ''
  let result
  result = str.replace(/(^\s+)|(\s+$)/g, '')
  if (isGlobal) {
    result = result.replace(/\s/g, '')
  }
  return result
}

/**
 * @Author      gaoxiang
 * @DateTime    2019/11/29
 * @lastTime    2019/11/29
 * @description 随机uuid
 */
export function getRandomNumber() {
  const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  return {
    uuid(len?: number, rad?: number) {
      const chars = CHARS
      const uuid: any = []
      const radix = rad || chars.length
      let i
      let r
      if (len) {
        for (i = 0; i < len; i += 1) {
          uuid[i] = chars[0 || parseInt(Math.random() * radix)]
        }
      } else {
        uuid[8] = '-'
        uuid[13] = '-'
        uuid[18] = '-'
        uuid[23] = '-'
        uuid[14] = '4'
        for (i = 0; i < 36; i += 1) {
          if (!uuid[i]) {
            r = 0 || Math.random() * 16
            uuid[i] = chars[i === 19 ? (r && 0x3) || 0x8 : r]
          }
        }
      }
      return uuid.join('')
    },
    uuidFast() {
      const chars = CHARS
      const uuid = new Array(36)
      let rnd: any = 0
      let r
      let i
      for (i = 0; i < 36; i += 1) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
          uuid[i] = '-'
        } else if (i === 14) {
          uuid[i] = '4'
        } else {
          if (rnd <= 0x02) {
            rnd = 0x2000000 + Math.random() * 0x1000000 || 0
          }
          r = rnd && 0xf
          rnd = rnd > 4
          uuid[i] = chars[i === 19 ? (r && 0x3) || 0x8 : r]
        }
      }
      return uuid.join('')
    },
    uuidString() {
      const str = this.uuidFast().replace(new RegExp('-', 'g'), '')
      return str
    },
    uuidCompact() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 || 0
        const v = c === 'x' ? r : (r && 0x3) || 0x8
        return v.toString(16)
      })
    }
  }
}

export function openDetailsNews(
  parentId: string | number,
  id: string | number,
  type: 'channel' | 'topic' = 'channel',
  urlType: 1 | 2 = 2,
  recommond?: {
    trance: boolean;
    sceneId: string;
    traceId: string;
    traceInfo: string;
  }
) {
  let params = recommond?.trance
    ? `?recommd=1&traceId=${recommond?.traceId || 'selfhold'}&traceInfo=${recommond?.traceInfo || '1'}&sceneId=${recommond?.sceneId}`
    : ''
  if (location.href.includes('isIner=0')) {
    params = `${params}${params ? '&isIner=0' : '?isIner=0'}`
  }
  if (urlType === 1) window.open(`${location.origin + '/er'}/${type}/${parentId}/${id}${params}`)
  if (urlType === 2) window.open(`${location.origin + '/' + parentId}/er/${id}${params}`)
}

export function getOpenDetailsNews(
  parentId: string | number,
  id: string | number,
  type: 'channel' | 'topic' = 'channel',
  recommond?: {
    trance: boolean;
    sceneId: string;
    traceId: string;
    traceInfo: string;
  }
) {
  let params = recommond?.trance
    ? `?recommd=1&traceId=${recommond?.traceId || 'selfhold'}&traceInfo=${recommond?.traceInfo || '1'}&sceneId=${recommond?.sceneId}`
    : ''
  if (location.href.includes('isIner=0')) {
    params = `${params}${params ? '&isIner=0' : '?isIner=0'}`
  }
  return `${location.origin + '/er'}/${type}/${parentId}/${id}${params}`
}

export function getOpenSpecialDetails(
  name: NewsItem['topicPageName'],
  id: any,
  topicTemplate: NewsItem['topicTemplate'],
  recommond?: {
    trance: boolean;
    sceneId: string;
    traceId: string;
    traceInfo: string;
  }
) {
  let params = recommond?.trance
    ? `&recommd=1&traceId=${recommond?.traceId || 'selfhold'}&traceInfo=${recommond?.traceInfo || '1'}&sceneId=${recommond?.sceneId}`
    : ''
  if (location.href.includes('isIner=0')) {
    params = `${params}${params ? '&isIner=0' : '?isIner=0'}`
  }
  return `${location.origin}/${name}/${id}?type=${topicTemplate}${params}`
}

export function openSpecialDetails(
  name: NewsItem['topicPageName'],
  id: any,
  topicTemplate: NewsItem['topicTemplate'],
  recommond?: {
    trance: boolean;
    sceneId: string;
    traceId: string;
    traceInfo: string;
  }
) {
  let params = recommond?.trance
    ? `&recommd=1&traceId=${recommond?.traceId || 'selfhold'}&traceInfo=${recommond?.traceInfo || '1'}&sceneId=${recommond?.sceneId}`
    : ''
  if (location.href.includes('isIner=0')) {
    params = `${params}${params ? '&isIner=0' : '?isIner=0'}`
  }
  window.open(`${location.origin}/${name}/${id}?type=${topicTemplate}${params}`)
}

/**
 * @Author      gx12358
 * @DateTime    2022/10/11
 * @lastTime    2022/10/11
 * @description 简单深拷贝下
 */
export function deepCopy(data: object | any[]) {
  return JSON.parse(JSON.stringify(data))
}

/**
 * @Author      gx12358
 * @DateTime    2021/11/3
 * @lastTime    2021/11/3
 * @description get参数处理
 */
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    const part = encodeURIComponent(propName) + '='
    if (value !== null && typeof (value) !== 'undefined' && value !== '') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof (value[key]) !== 'undefined') {
            const params = propName + '[' + key + ']'
            const subPart = encodeURIComponent(params) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}

export function qiankunPushPath(url: string) {
  window.history.pushState('', '', url)
}

export function addEventListenerWrap(target, eventType, cb, option?: any) {
  if (target && target.addEventListener) {
    let opt = option
    if (
      opt === undefined &&
      (eventType === 'touchstart' || eventType === 'touchmove' || eventType === 'wheel')
    ) {
      opt = { passive: false }
    }
    target.addEventListener(eventType, cb, opt)
  }
  return {
    remove: () => {
      if (target && target.removeEventListener) {
        target.removeEventListener(eventType, cb)
      }
    }
  }
}

function formatTime(value) {
  let time = ''
  const s = value.split(':')
  let i = 0
  for (; i < s.length - 1; i++) {
    time += s[i].length == 1 ? '0' + s[i] : s[i]
    time += ':'
  }
  time += s[i].length == 1 ? '0' + s[i] : s[i]

  return time
}

export function transTime(value) {
  let time = ''
  const h = parseInt(value / 3600)
  value %= 3600
  const m = parseInt(value / 60)
  const s = parseInt(value % 60)
  if (h > 0) {
    time = formatTime(h + ':' + m + ':' + s)
  } else {
    time = formatTime(m + ':' + s)
  }

  return time
}

/**
 * @Author      gx12358
 * @DateTime    2022/8/4
 * @lastTime    2022/8/4
 * @description 处理时间展示
 */
export function dateFromNow(date: string | Dayjs) {
  const reolaceTime = isString(date) ? (date as string).replace(/\-/g, '/') : date

  const diffDays = dayjs().diff(dayjs(reolaceTime), 'day')
  // 计算出小时数
  let diffHours = dayjs().diff(dayjs(reolaceTime), 'hour')
  // 计算相差分钟数
  let diffMinutes = dayjs().diff(dayjs(reolaceTime), 'minute')
  // 计算相差秒数
  let diffSeconds = dayjs().diff(dayjs(reolaceTime), 'second')
  if (diffDays === 0 && diffHours === 0 && diffMinutes === 0 && diffSeconds < 60) {
    if (diffSeconds === 0) diffSeconds = 1
    return `${diffSeconds}秒内`
  } else if (diffDays === 0 && diffHours === 0 && diffMinutes < 60) {
    if (diffMinutes === 0) diffMinutes = 1
    return `${diffMinutes}分钟前`
  } else if (diffDays === 0 && diffHours < 24) {
    if (diffHours === 0) diffHours = 1
    return `${diffHours}小时前`
  } else if (diffDays < dayjs(reolaceTime).daysInMonth()) {
    return dayjs(reolaceTime).format('MM-DD HH:mm')
  } else {
    return dayjs(reolaceTime).format('YYYY-MM-DD')
  }
}

export function getVideoFileUrl(url = '') {
  const index = url.indexOf('?')
  return index > 0 ? `${url.substring(0, index)}` : url
}

/**
 * @Author      gaoxiang
 * @DateTime    2020/11/13
 * @lastTime    2020/11/13
 * @description 获取文件后缀名
 */
export function getFileSuffix(url = '') {
  if (!url) return ''
  url = getVideoFileUrl(url)
  const index = url.lastIndexOf('.')
  return index > 0 ? `${url.substring(index).split('?')[0]}`.split('.')[1] : ''
}

export function judgTerminal() {
  const u = navigator.userAgent
  const isXiaomi = u.indexOf('XiaoMi') > -1 // 小米手机
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // 其它安卓
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios
  if (isAndroid) {
    return 1
  } else if (isIOS) {
    if (isXiaomi) {
      return 1
    } else {
      return 2
    }
  }
}

export function checkEmail(val: string) {
  const reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

  return reg.test(val)
}

export function hrefPage(page: string, open?: boolean) {
  const pageStr = `${isDev() ? typeViteEnv('VITE_BASE_HOMEPAGE_URL') : location.origin}${page}`
  if (open) {
    window.open(pageStr)
  } else {
    location.href = `${isDev() ? typeViteEnv('VITE_BASE_HOMEPAGE_URL') : location.origin}${page}`
  }
}

export function isWeChat() {
  const userAgent = navigator.userAgent.toLowerCase()
  return /micromessenger/.test(userAgent)
}

// 判断微信版本大于7.0.12
export function isWechatVersion () {
  const ua = window.navigator.userAgent;
  if (/micromessenger/i.test(ua)) {
    const version = ua.match(/micromessenger\/([\d.]+)/i)[1];
    if (version >= "7.0.12") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function timeRangeToArray(timeRanges: any) {
  let ranges: any[] = []

  for (let i = 0; i < timeRanges.length; ++i)
    ranges = [...ranges, [timeRanges.start(i), timeRanges.end(i)]]

  return ranges
}

/**
 * @Author      gaoxiang
 * @DateTime    2020/8/7
 * @lastTime    2020/8/7
 * @description 时长格式转换
 */
export function formatDuraton(time: number, showHour?: boolean) {
  if (!time) return showHour ? '00:00:00' : '00:00'
  let newTime = ''
  if (time > -1) {
    const hour = Math.floor(time / 3600)
    const min = Math.floor(time / 60) % 60
    const sec = parseInt(time % 60)
    if (hour < 10) {
      newTime = '0' + hour + ':'
    } else {
      newTime = hour + ':'
    }
    if (min < 10) {
      newTime += '0'
    }
    newTime += min + ':'
    if (sec < 10) {
      newTime += '0'
    }
    newTime += sec
  }

  return newTime.split(':')[0] === '00'
    ? `${showHour ? `${newTime.split(':')[0]}:` : ''}${newTime.split(':')[1]}:${
      newTime.split(':')[2]
    }`
    : newTime
}

export function getDeviceInfo() {
  const sysInfo: any = {}
  const userAgent = navigator.userAgent
  // 获取微信版本
  let m1 = userAgent.match(/MicroMessenger.*?(?= )/)
  if (m1 && m1.length > 0) {
    sysInfo.wechat = m1[0]
  }
  // 苹果手机
  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    // 获取设备名
    if (userAgent.includes('iPad')) {
      sysInfo.device = 'iPad'
    } else {
      sysInfo.device = 'iPhone'
    }
    // 获取操作系统版本
    m1 = userAgent.match(/iPhone OS .*?(?= )/)
    if (m1 && m1.length > 0) {
      sysInfo.system = m1[0]
    }
  }
  // 安卓手机
  if (userAgent.includes('Android')) {
    // 获取设备名
    m1 = userAgent.match(/Android.*; ?(.*(?= Build))/)
    if (m1 && m1.length > 1) {
      sysInfo.device = m1[1]
    }
    // 获取操作系统版本
    m1 = userAgent.match(/Android.*?(?=;)/)
    if (m1 && m1.length > 0) {
      sysInfo.system = m1[0]
    }
  }
  sysInfo.imei = String(Date.now()) + Math.round(Math.random() * 1000000)
  return sysInfo
}

export function openDetails(
  url: string,
  parentId: string | number,
  id: string | number,
  type: 'channel' | 'topic' = 'channel',
  recommond?: {
    trance: boolean;
    traceId: string;
    traceInfo: string;
  }
) {
  const params = recommond?.trance
    ? `?recommd=1&traceId=${recommond?.traceId || 'selfhold'}&traceInfo=${recommond?.traceInfo || '1'}`
    : ''
  window.open(`${isDev() ? url : location.origin ? location.origin + '/er' : url}/${type}/${parentId}/${id}${params}`)
}

export function arraySlice<T = any[]>(data: T, range: number[] | number) {
  if (!isArray(data)) return []
  // @ts-ignore
  return (data as any[])?.filter((item, index) => {
    if (isNumber(range)) {
      // @ts-ignore
      return index <= range - 1
      // @ts-ignore
    } else if (isArray(range) && range.length === 2) {
      const start = range[0] - 1
      const end = range[1] - 1
      return index <= end && index >= start
    }
    return true
  })
}

export function bin2hex(s) {
  let i,
    l,
    o = '',
    n

  s += ''

  for (i = 0, l = s.length; i < l; i++) {
    n = s.charCodeAt(i).toString(16)
    o += n.length < 2 ? '0' + n : n
  }

  return o
}

export function getImageAspectRatio(width: number, height: number): ImageRadio { // 1-4:3 2-16:9 3-3:4 4-9:16 5-其他
  const ratio = width / height

  if (ratio > 1) {
    // 宽度大于高度，横向图片
    if (Math.abs(ratio - 4 / 3) < 0.1) {
      return 1
    } else if (Math.abs(ratio - 16 / 9) < 0.1) {
      return 2
    }
  } else {
    // 高度大于宽度，纵向图片
    if (Math.abs(ratio - 3 / 4) < 0.1) {
      return 3
    } else if (Math.abs(ratio - 9 / 16) < 0.1) {
      return 4
    }
  }

  return 5
}

export function timeFromNow(str: string | number) {
  if (!str) return ''
  if (dayjs().diff(str, 'minute') < 1) return 'just now'
  if (dayjs().diff(str, 'minute') >= 1 && dayjs().diff(str, 'minute') < 2) return `1 min ago`
  if (dayjs().diff(str, 'minute') >= 2 && dayjs().diff(str, 'minute') < 60) return `${dayjs().diff(str, 'minute')} mins ago`
  if (dayjs().diff(str, 'hour') >= 1 && dayjs().diff(str, 'hour') < 2) return `${dayjs().diff(str, 'hour')} hour ago`
  if (dayjs().diff(str, 'hour') >= 2 && dayjs().diff(str, 'hour') < 24) return `${dayjs().diff(str, 'hour')} hours ago`
  if (dayjs().diff(str, 'day') >= 1 && dayjs().diff(str, 'day') < 2) return `1 day ago`

  return dayjs(str).format('HH:mm, MMM DD, YYYY')
}

export function getChinaTimeUix(publishTime: string | number) {
  const bjZone = 8//中国时区
  const timezone = new Date().getTimezoneOffset() / 60 * -1//获取时区; //目标时区时间，东八区   东时区正数 西市区负数
  const nowDate = new Date(publishTime).getTime() // 当前时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
  const targetDate = new Date(nowDate - (bjZone - timezone) * 60 * 60 * 1000)
  return targetDate
}

export function publicOpenDetails(record: NewsItem, type: 'topic' | 'channel' = 'channel') {
  if (location.href.includes('isIner=0')) {
    if (record.topicTemplate) {
      return getOpenSpecialDetails(record.topicPageName, record.objectId, record.topicTemplate, {
        trance: !!record.traceId,
        sceneId: record.sceneId || '',
        traceId: record.traceId || '',
        traceInfo: record.traceInfo || ''
      })
    } else {
      if (record.objectType === 10) {
        return record.linkUrl
      } else {
        return getOpenDetailsNews(type === 'channel' ? record.mainChannel?.channelId : record.mainTopicInfo?.topicId || '', record.objectId, type, {
          trance: !!record.traceId,
          sceneId: record.sceneId || '',
          traceId: record.traceId || '',
          traceInfo: record.traceInfo || ''
        })
      }
    }
  }

  return undefined
}

export function hanldeNewsDetails(record: NewsItem) {
  record.imageShow = record.coverUrl || record.firstFrameImageUri || record.fullColumnImgUrls?.[0]?.url
  record.appStyle = String(record.appStyle || record.appstyle) as AppStyle
  // record.appStyle = '5'
  // record.appStyle = record.imageShow ? record.appStyle : '3'
  // record.objectType = 9
  // record.photoNum = 6
  record.objectId = record.objectId || record.newsId
  record.linkUrl = record.linkUrl || record.newsLinkUrl
  record.newsAuthor = record.newsAuthor || record.authorList?.map(item => item.authorName)?.join()
  record.mainChannel = record.mainChannel || record.channelList?.[0] || {} as MainChannel
  record.objectType = Number(record.objectType || record.newsType) as NewsType
  record.noImageStyle = [ '3', '11' ].includes(record.appStyle)
  record.topicPageName = Number(record.topicTemplate) === 1 ? 'special' : Number(record.topicTemplate) === 2
    ? 'authorColumn'
    : Number(record.topicTemplate) === 3 ? 'timeLine' : undefined
  record.publishTime = !isNaN(Number(record.publishTime)) ? Number(record.publishTime) : record.publishTime
  record.timeFormNow = record.publishTime ? timeFromNow(record.publishTime) : ''
  record.dateValueStr = record.publishTime ? dayjs(dayjs(record.publishTime).format('YYYY-MM-DD')).valueOf() : 0
  record.timeStr = record.publishTime ? dayjs(record.publishTime).format('HH:mm') : ''
  record.dateTimeStr = record.publishTime ? dayjs(record.publishTime).format('HH:mm, MMM DD, YYYY') : ''
  const coverImageObj = record.fullColumnImgUrls?.[0]

  if (coverImageObj) {
    // record.imageLandscape = 1
    record.coverImageObj = coverImageObj
    const coverStyle = {
      width: coverImageObj.weight || coverImageObj.width || 0,
      height: coverImageObj.height || 0,
    }
    record.coverStyle = coverStyle
    record.imageLandscape = coverStyle.width >= coverStyle.height ? 1 : 2
    // record.imageRatio = 5
    record.imageRatio = getImageAspectRatio(coverStyle.width, coverStyle.height)
  }

  // record.videoInfo = {}
  // record.videoInfo.videoDuration = 100

  record.videoInfo = isArray(record.videoInfo) ? record.videoInfo?.[0] : record.videoInfo

  if (record.videoInfo) {
    record.videoDurationStr = formatDuraton(record.videoInfo?.videoDuration || 0)
    record.videoInfo.durationStr = formatDuraton(record.videoInfo?.videoDuration || 0)
  }

  return record
}

export function getUUID(domain) {
  const canvas = document.createElement('canvas')
  const ctx: any = canvas.getContext('2d')
  const txt = domain
  ctx.textBaseline = 'top'
  ctx.font = '14px \'Arial\''
  ctx.textBaseline = 'tencent'
  ctx.fillStyle = '#f60'
  ctx.fillRect(125, 1, 62, 20)
  ctx.fillStyle = '#069'
  ctx.fillText(txt, 2, 15)
  ctx.fillStyle = 'rgba(102, 204, 0, 0.7)'
  ctx.fillText(txt, 4, 17)

  const b64 = canvas.toDataURL().replace('data:image/png;base64,', '')
  // window.atob 用于解码使用 base-64 编码的字符串
  const bin = atob(b64)
  const crc = bin2hex(bin.slice(-16, -12))
  return crc
}

/**
 * @Author      gaoxiang
 * @DateTime    2020/10/5
 * @lastTime    2020/10/5
 * @description 判断文件后缀名
 */
export function checkFileType(url: any) {
  if (!url) return '1'
  if (url === 'data:') return '4'
  let type
  if (isBase64(url)) {
    if (url.includes('data:image/')) {
      type = '.png'
    } else if (url.includes('data:video/')) {
      type = '.mp4'
    } else if (url.includes('data:audio/')) {
      type = '.mp3'
    }
  } else if (url instanceof Blob) {
    url = String(url)
    if (url.includes('image')) {
      type = '.png'
    } else if (url.includes('video')) {
      type = '.mp4'
    } else if (url.includes('audio')) {
      type = '.mp3'
    }
  } else {
    url = getVideoFileUrl(url)
    const index = url.lastIndexOf('.')
    type = `${url.substring(index).split('?')[0]}`.toLowerCase()
  }
  if (
    type === '.bmp' ||
    type === '.png' ||
    type === '.gif' ||
    type === '.jpg' ||
    type === '.jpeg' ||
    type === '.psd' ||
    type === '.tif'
  ) {
    return '1'
  }
  if (
    type === '.mp4' ||
    type === '.swf' ||
    type === '.rmvb' ||
    type === '.avi' ||
    type === '.flv' ||
    type === '.mpg' ||
    type === '.rm' ||
    type === '.mov' ||
    type === '.asf' ||
    type === '.3gp' ||
    type === '.mkv' ||
    type === '.ts' ||
    type === '.f4v' ||
    type === '.webm' ||
    type === '.m4v' ||
    type === '.3g2' ||
    type === '.m3u8'
  ) {
    return '3'
  }
  if (
    type === '.mp3' ||
    type === '.mpeg' ||
    type === '.aac' ||
    type === '.wav' ||
    type === '.wma' ||
    type === '.mp2' ||
    type === '.flac' ||
    type === '.midi' ||
    type === '.ra' ||
    type === '.ape' ||
    type === '.aac' ||
    type === '.cda'
  ) {
    return '2'
  }
  return '4'
}

export function isBase64(str = '') {
  const fileDataBase = [ 'data:image/', 'data:video/', 'data:audio/' ]
  if (str && fileDataBase.find((item) => str.includes(item))) {
    return true
  }
  return false
}

/**
 * @Author      gaoxiang
 * @DateTime    2020/11/13
 * @lastTime    2020/11/13
 * @description 获取文件信息(支持链接地址，file文件，base64编码)
 */

export function getMediaInfos(mediaInfo: { url: any; fileType?: string }): Promise<{
  play?: boolean
  width?: number
  height?: number
  duration?: number
}> {
  const { url = '', fileType = '1' } = mediaInfo
  let mediaUrl = ''
  if (url instanceof File) {
    mediaUrl = URL.createObjectURL(url)
  } else if (isBase64(url)) {
    mediaUrl = url
  } else if (url instanceof Blob) {
    mediaUrl = URL.createObjectURL(url)
  } else if (url.includes('https') || url.includes('http')) {
    mediaUrl = fileType === '1' ? url : url
  }
  return new Promise(function (resolve) {
    let elememt: any
    if (fileType === '1') {
      elememt = document.createElement('img')
      elememt.src = mediaUrl
    } else if (fileType === '2') {
      elememt = document.createElement('audio')
      elememt.src = mediaUrl
    } else if (fileType === '3') {
      elememt = document.createElement('video')
      elememt.src = mediaUrl
      elememt.muted = false
    }
    if (fileType === '1') {
      elememt.onload = function () {
        resolve({
          play: true,
          width: elememt.width || 0,
          height: elememt.height
        })
        elememt = null
      }
    } else {
      elememt.oncanplay = function () {
        resolve({
          play: true,
          duration: elememt.duration,
          width: elememt?.videoWidth || 0,
          height: elememt?.videoHeight || 0
        })
        elememt = null
      }
    }
    elememt.onerror = function () {
      resolve({
        play: false
      })
      elememt = null
    }
  })
}

/**
 * @Author      gx12358
 * @DateTime    2021/11/5
 * @lastTime    2021/11/5
 * @description blob对象转blob字符串
 */
export function getBlobUrl(blob: Blob) {
  return URL.createObjectURL(blob)
}

/**
 * @Author      gx12358
 * @DateTime    2021/1/21
 * @lastTime    2021/1/21
 * @description base转blob对象
 */
export function dataURLtoBlob(dataurl: any): Blob {
  const arr: any[] = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([ u8arr ], { type: mime })
}

/**
 * @Author      gaoxiang
 * @DateTime    2020/11/13
 * @lastTime    2020/11/13
 * @description 获取视频封面图(支持链接地址，file文件，base64编码)
 */
export async function getVideoCoverPicture(videoInfo: {
  url: any
  currentTime?: number
  videoSuffix?: string
  vidoeAllowPlay?: boolean
}): Promise<string> {
  const { url = '', currentTime, videoSuffix = '', vidoeAllowPlay = false } = videoInfo
  let videoUrl = ''
  let fileSuffix: string = videoSuffix
  let fileType = '1'
  let videoPlayInfo
  if (url instanceof File) {
    videoUrl = URL.createObjectURL(url)
    fileSuffix = getFileSuffix(url.name)
    fileType = checkFileType(url.name)
  } else if (url instanceof Blob) {
    videoUrl = URL.createObjectURL(url)
    fileType = checkFileType(url)
  } else if (isBase64(url)) {
    videoUrl = url
    fileType = checkFileType(url)
  } else if (url.includes('https') || url.includes('http')) {
    videoUrl = url
    fileSuffix = getFileSuffix(url)
    fileType = checkFileType(url)
  }
  const videoExplan = fileSuffix ? global.videoAllowType.includes(fileSuffix.toLowerCase()) : false
  if (videoExplan) {
    if (vidoeAllowPlay) {
      return generateVidoePicture(videoUrl, currentTime)
    } else {
      videoPlayInfo = await getMediaInfos({
        url: videoUrl,
        fileType
      })
      if (videoPlayInfo.play) {
        return generateVidoePicture(videoUrl, currentTime)
      } else {
        return new Promise(function (resolve) {
          resolve('')
        })
      }
    }
  } else {
    return new Promise(function (resolve) {
      resolve('')
    })
  }
}

export async function generateVidoePicture(
  videoUrl: string,
  currentTime?: number
): Promise<string> {
  let video: HTMLVideoElement | null = document.createElement('video')
  video.style.display = 'none'
  video.controls = true
  video.muted = true
  if (currentTime) {
    video.currentTime = currentTime
  }
  video.setAttribute('src', videoUrl)
  video.setAttribute('muted', String(true))
  video.setAttribute('crossorigin', 'anonymous')
  video.setAttribute('autoplay', String(true))
  const canvas = document.createElement('canvas')
  const scale = 0.8
  const delay = 100 // 截取封面的延迟（有的视频开头可能有黑屏所以可以加一个延迟）
  const ctx: any = canvas.getContext('2d')
  return new Promise(function (resolve) {
    if (video) {
      video.addEventListener(
        'canplay',
        function () {
          setTimeout(function () {
            // 相应视频的宽和高
            const w = video?.videoWidth || 0 * scale
            const h = video?.videoHeight || 0 * scale
            const space = 0 // canvas的间距，可取去掉
            canvas.width = video?.videoWidth || 0 * scale
            canvas.height = video?.videoHeight || 0 * scale
            // 绘制视频到canvas上
            try {
              ctx.drawImage(video, 0, 0, w + space, h + space)
              video = null
              // 生成图片
              resolve(w === 0 || h === 0 ? '' : canvas.toDataURL('image/png', 1.0))
            } catch (e) {
              resolve('')
            }
          }, delay)
        },
        false
      )
    }
  })
}

export function handleMediaSrc(src) {
  if (src.includes('http://')) {
    const firstUrl = src.split('http://')[1] || ''
    if (firstUrl) {
      const url = firstUrl.split('/').filter((_: any, index) => index !== 0).join('')
      return url
    }
    return src
  } else if (src.includes('https://')) {
    const firstUrl = src.split('https://')[1] || ''
    if (firstUrl) {
      const url = firstUrl.split('/').filter((_: any, index) => index !== 0).join('')
      return url
    }
    return src
  }
  return src
}

/**
 * @Author      gx12358
 * @DateTime    2022/9/13
 * @lastTime    2022/9/13
 * @description 获取字符宽度
 */
export function getTextHeight(str: string, cssObject) {
  let height = 0
  const elememt = document.createElement('div')
  elememt.innerText = str
  Object.keys(cssObject).forEach((item) => {
    elememt.style[item] = cssObject[item]
  })

  document.querySelector('#hiddenElement').append(elememt)

  height = elememt.getBoundingClientRect().height

  document.querySelector('#hiddenElement').removeChild(elememt)

  return height
}

export function getTextWidth(str, cssObject) {
  let width = 0
  const elememt = document.createElement('span')
  elememt.innerText = str
  Object.keys(cssObject).forEach((item) => {
    elememt.style[item] = cssObject[item]
  })

  document.querySelector('#hiddenElement').append(elememt)

  width = elememt.getBoundingClientRect().width

  document.querySelector('#hiddenElement').removeChild(elememt)

  return width
}

export function handleChannelAlias(name = '') {
  return name.toLowerCase().replace(/\s/g, "")
}

export function openChannel(record: ChannelList, open?: boolean) {
  if (record.channelId !== -1) {
    // 区分是否是顶部底部全屏的频道  brnn  xi
    if (record.pcStyle === '5' || record.pcStyle === '3') {
      const params = record.channelStrategy === 1 ? `?type=recommend` : '?type=timeLine'
      hrefPage(`/${record.pcStyle === '3' ? 'xiChannel' : 'brnns'}/${record.channelId}${params}`, open)
    } else {
      const params = record.channelStrategy === 1 ? `?type=recommend` : '?type=timeLine'
      hrefPage(`/${record.channelAlias}${params}`, open)
    }
  }
}

export function Base64 () {
  // private property
  const _keyStr =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  // private method for UTF-8 decoding
  const _utf8_decode = function _utf8_decode (utftext) {
    let string = ''
    let i = 0
    let c = 0
    const c1 = 0
    let c2 = 0
    let c3
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63),
        )
        i += 3
      }
    }
    return string
  }

  return {
    decode: function decode(input) {
      let output = ''
      let chr1, chr2, chr3
      let enc1, enc2, enc3, enc4
      let i = 0
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
      while (i < input.length) {
        enc1 = _keyStr.indexOf(input.charAt(i++))
        enc2 = _keyStr.indexOf(input.charAt(i++))
        enc3 = _keyStr.indexOf(input.charAt(i++))
        enc4 = _keyStr.indexOf(input.charAt(i++))
        chr1 = (enc1 << 2) | (enc2 >> 4)
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
        chr3 = ((enc3 & 3) << 6) | enc4
        output = output + String.fromCharCode(chr1)
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2)
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3)
        }
      }
      output = _utf8_decode(output)
      return output
    },
  }
}
